import constants from 'constants/index'

const labels = {
  [constants.fragilityEntities.COMPANY_ENTITY_TYPE]: 'Toda a empresa',
  [constants.fragilityEntities.DEPARTMENT_ENTITY_TYPE]: 'Departamento',
  [constants.fragilityEntities.DATA_PROCESS_ENTITY_TYPE]: 'Processo',
}

export default labels
